import type { ListingStatus } from "@loot-os/fulfillment-core/listing/types";

/** The label of each vendor listing status, shared by the Listings filter and its row badge. */
export const LISTING_STATUS_LABELS: Record<ListingStatus, string> = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  IMAGE_PROCESSING: "IMAGE PROCESSING",
};
